'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _editFinanceCompanyModal = require('./editFinanceCompany.modal.html');

var _editFinanceCompanyModal2 = _interopRequireDefault(_editFinanceCompanyModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FinanceCompaniesContainerController = function () {
  function FinanceCompaniesContainerController(authService, enums, $stateParams, loadingService, $scope, $uibModal, financeCompaniesManagementService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, FinanceCompaniesContainerController);
    this.$stateParams = $stateParams;
    this.loadingService = loadingService;
    this.$scope = $scope;
    this.$uibModal = $uibModal;
    this.financeCompaniesManagementService = financeCompaniesManagementService;

    this.financeCompanies = [];
    this.initializeFinanceCompanies();

    this.state = '';
    this.resetNotification();
  }

  (0, _createClass3.default)(FinanceCompaniesContainerController, [{
    key: 'resetNotification',
    value: function resetNotification() {
      this.notification = {
        type: '',
        msg: ''
      };
    }
  }, {
    key: 'initializeFinanceCompanies',
    value: function initializeFinanceCompanies() {
      var ctrl = this;

      ctrl.loadingService.showLoading('financeCompaniesList', 'Loading Finance Companies ...');

      ctrl.financeCompaniesManagementService.listFinanceCompanies(ctrl.$stateParams.locationId).then(function (response) {
        ctrl.financeCompanies = response.data.items;
      }).finally(function () {
        ctrl.loadingService.hideLoading('financeCompaniesList');
      });
    }
  }, {
    key: 'removeFinanceCompany',
    value: function removeFinanceCompany(financeCompany) {
      var ctrl = this;

      ctrl.loadingService.showLoading('financeCompaniesList', 'Removing Finance Company ...');

      ctrl.financeCompaniesManagementService.removeFinanceCompany(ctrl.$stateParams.locationId, financeCompany.financeCompanyId).finally(function () {
        ctrl.loadingService.hideLoading('financeCompaniesList');
        ctrl.initializeFinanceCompanies();
      });
    }
  }, {
    key: 'showAdd',
    value: function showAdd() {
      this.$scope.errMsg = "";
      this.$scope.tempCompany = {
        entityId: this.$stateParams.locationId,
        buyRate: 0,
        sellRate: 0
      };

      this.$scope.closeModal = this.closeModal.bind(this);
      this.$scope.save = this.save.bind(this);

      this.$scope.modalInstance = this.$uibModal.open({
        template: _editFinanceCompanyModal2.default,
        scope: this.$scope
      });
    }
  }, {
    key: 'showEdit',
    value: function showEdit(financeCompany) {
      this.$scope.errMsg = "";
      this.$scope.tempCompany = financeCompany;

      this.$scope.closeModal = this.closeModal.bind(this);
      this.$scope.save = this.save.bind(this);

      this.$scope.modalInstance = this.$uibModal.open({
        template: _editFinanceCompanyModal2.default,
        scope: this.$scope
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      var ctrl = this;

      if (ctrl.$scope.modalInstance) {
        ctrl.$scope.modalInstance.close();
      }
    }
  }, {
    key: 'save',
    value: function save() {
      var ctrl = this;

      if (!ctrl.validateForm(ctrl.$scope.tempCompany.financeCompanyId)) {
        return;
      }

      if (!ctrl.$scope.tempCompany.financeCompanyId) {
        ctrl.add();
      } else {
        ctrl.edit();
      }
    }
  }, {
    key: 'add',
    value: function add() {
      var _this = this;

      var ctrl = this;

      ctrl.financeCompaniesManagementService.addFinanceCompany(ctrl.$scope.tempCompany).then(function (response) {
        ctrl.financeCompanies.push({
          financeCompanyId: response.data,
          entityId: _this.$stateParams.locationId,
          name: ctrl.$scope.tempCompany.name,
          buyRate: ctrl.$scope.tempCompany.buyRate,
          sellRate: ctrl.$scope.tempCompany.sellRate
        });
      }).finally(function () {
        ctrl.closeModal();
      });
    }
  }, {
    key: 'edit',
    value: function edit() {
      var ctrl = this;

      ctrl.financeCompaniesManagementService.editFinanceCompany(ctrl.$scope.tempCompany).then(function (response) {}).finally(function () {
        ctrl.closeModal();
      });
    }
  }, {
    key: 'validateForm',
    value: function validateForm(financeCompanyId) {
      var ctrl = this;

      ctrl.$scope.errMsg = '';

      if (!ctrl.$scope.tempCompany.name || ctrl.$scope.tempCompany.name.length < 3 || ctrl.$scope.tempCompany.name.length > 50) {
        ctrl.$scope.errMsg = 'Name is a required field and must be between 3 and 50 characters';
        return false;
      }

      if (ctrl.$scope.tempCompany.buyRate !== '' && ctrl.$scope.tempCompany.buyRate < 0) {
        ctrl.$scope.errMsg = 'Buy Rate is a required field';
        return false;
      }

      if (ctrl.$scope.tempCompany.sellRate !== '' && ctrl.$scope.tempCompany.sellRate < 0) {
        ctrl.$scope.errMsg = 'Sell Rate is a required field';
        return false;
      }

      if (ctrl.$scope.tempCompany.sellRate < ctrl.$scope.tempCompany.buyRate) {
        ctrl.$scope.errMsg = 'Buy Rate cannot be greater than Sell Rate';
        return false;
      }

      if ((0, _lodash.find)(this.financeCompanies, function (fc) {
        var removeEdit = false;
        if (financeCompanyId) {
          removeEdit = fc.financeCompanyId !== financeCompanyId;
        }

        return fc.name.toLowerCase() === ctrl.$scope.tempCompany.name.toLowerCase() && removeEdit;
      })) {
        ctrl.$scope.errMsg = ctrl.$scope.tempCompany.name + ' is already added to the list';
        return;
      }

      return true;
    }
  }]);
  return FinanceCompaniesContainerController;
}();

exports.default = FinanceCompaniesContainerController;


// WEBPACK FOOTER //
// ./client/app/components/admin/financeCompaniesManagement/financeCompaniesContainer/financeCompaniesContainer.controller.js